import { filter, prop, pipe, either, equals, evolve, always, append, identity, ifElse } from 'ramda'
import { makeObj } from '@v/util/briqRamdaExt'

const isDeletedOrInactive = pipe(
  prop('ProductActiveState'),
  either(equals('Deleted'), equals('Inactive')),
)

const appendBookingProduct = pipe(
  makeObj({
    NameInternal: prop('ProductName'),
    Key: prop('ProductKey'),
    $isDisabled: always(true),
  }),
  append,
)

export const maybeAppendBookingProduct = ifElse(
  isDeletedOrInactive,
  appendBookingProduct,
  () => identity,
)
